const state = {
  params: {}
};

const mutations = {
  SET_PARAMS: (state, type) => {
    state.params = type;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
